import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";

import { Booking } from "../../bookingClass";
import ServerAPI from "../../lib/server";
import Preloader from "../ui/Preloader";
import BookingFormTariffs from "./BookingFormTariffs";
import BookingFormContacts from "./BookingFormContacts";
import BookingFormFinal from "./BookingFormFinal";
import BookingFormServices from "./BookingFormServices";
import searchStore from "../../store/searchStore";

import "./booking.scss";

function BookingWindow({ bookingData, onClose }) {
  const [hoteldata, setHoteldata] = useState(null);
  const [loading, setLoading] = useState(true);
  const [currentStep, setCurrentStep] = useState("tariffs");
  const [finalData, setFinalData] = useState({});
  const [datein, setDatein] = useState(
    bookingData?.datein || searchStore.dateCheckin,
  );
  const [dateout, setDateout] = useState(
    bookingData?.dateout || searchStore.dateCheckout,
  );

  const [booking, setBooking] = useState({ needRefresh: 0 });
  const [needRefresh, setNeedRefresh] = useState(0);

  useEffect(() => {
    // console.log("bookingData", bookingData);
    if (!hoteldata) {
      ServerAPI.customPostQuery(
        `/booking/info/${bookingData.hotel}/${bookingData.room}`,
        {
          tariff: bookingData.tariff,
          food: bookingData.food,
          datein: datein,
          dateout: dateout,
          guests: searchStore.guestsCount,
          child: searchStore.guestsChildren,
          dog_friendly: searchStore.dogFriendly,
        },
      )
        .then((res) => {
          const new_booking = new Booking(
            res.hotel.tariffs,
            bookingData,
            setNeedRefresh,
          );
          setBooking(new_booking);
          setHoteldata({
            ...res.hotel,
            steps_count: 2,
            // steps_count: res.hotel?.services?.service?.length > 0 ? 3 : 2,
          });
          // установить вариант номера
          if (res.hotel?.separate && res.hotel?.numbers?.length > 0) {
            new_booking.setSelectedNumber(
              bookingData?.number || res.hotel.numbers[0].id,
            );
          }
          setLoading(false);
        })
        .catch((err) => {
          console.log("err", err);
          toast.error(err);
          onClose();
        });
    }
    // при первом открытии окна установить выбранный вариант номера, если передан
    // if (needRefresh == 0 && bookingData.number != 0) {
    //   booking.setSelectedNumber(bookingData.number);
    // }
  }, [needRefresh]);

  const nextStep = () => {
    setCurrentStep("contacts");
    // if (hoteldata.steps_count == 2) {
    //   // всего два шага, следующие - это всегда контакты
    //   setCurrentStep("contacts");
    // } else {
    //   // шагов 3 (товары и услуги), следующий в зависимости от текущего
    //   if (currentStep == "tariffs") {
    //     setCurrentStep("services");
    //   } else {
    //     setCurrentStep("contacts");
    //   }
    // }
  };

  const prevStep = () => {
    setCurrentStep("tariffs");
    // if (hoteldata.steps_count == 2) {
    //   // всего два шага, предыдущий - всегда тарифы
    //   setCurrentStep("tariffs");
    // } else {
    //   // шагов 3 (товары и услуги), предыдущий в зависимости от текущего
    //   if (currentStep == "services") {
    //     setCurrentStep("tariffs");
    //   } else {
    //     setCurrentStep("services");
    //   }
    // }
  };

  // отправка формы
  const bookingHandler = (data) => {
    const bookingForm = {
      hotel_id: bookingData.hotel,
      room_id: bookingData.room,
      number: booking.selectedNumber,
      tariff: bookingData.tariff,
      food: bookingData.food,
      datein: hoteldata.tariffs.start_date,
      dateout: hoteldata.tariffs.end_date,
      guests: searchStore.guestsCount,
      child: searchStore.guestsChildren,
      dog_friendly: searchStore.dogFriendly,
      form: data,
      dop_tariffs: [],
      additional_tariff: null,
      services: [],
    };
    if (booking.selectedTariffs?.length > 0) {
      booking.selectedTariffs.forEach((t) => {
        bookingForm.dop_tariffs.push({ id: t.id, sum: t.sum });
      });
    }
    if (booking.selectedAdditionalTariffs?.length > 0) {
      bookingForm.additional_tariff = booking.selectedAdditionalTariffs[0].id;
    }
    if (booking.selectedServices?.length > 0) {
      booking.selectedServices.forEach((s) => {
        if (s.service_is_personal_time == 2) {
          bookingForm.services.push({
            id: s.id,
            add_id: s.add_id,
            count: s.count,
            date: s.date,
            duration: s.duration,
            technical_break: s.technical_break,
            hour: s.hour,
            minute: s.minute,
            h_end: s.h_end,
            m_end: s.m_end,
            h_end_p: s.h_end_p,
            m_end_p: s.m_end_p,
          });
        } else {
          bookingForm.services.push({ id: s.id, count: s.count });
        }
      });
    }
    // bookingForm.form.name = searchStore.userData.name;
    // bookingForm.form.surname = searchStore.userData?.lastname || "";
    // bookingForm.form.email = searchStore.userData.email;
    // bookingForm.form.phone = bookingForm.form.phone.replace(/\D/g, "");

    // console.log("booking", bookingForm);
    // return;
    ServerAPI.customPostQuery("/booking/create", bookingForm).then((res) => {
      // если пришел редирект на оплату
      if (res.paymentUrl) {
        // window.open(res.paymentUrl);
        window.location.href = res.paymentUrl;
        setCurrentStep("redirect");
      } else {
        setCurrentStep("final");
        setFinalData(res);
      }
    });
  };

  if (loading) {
    return <Preloader />;
  }

  return (
    <>
      {currentStep === "tariffs" && (
        <BookingFormTariffs
          booking={booking}
          bookingData={bookingData}
          hoteldata={hoteldata}
          nextStep={nextStep}
          datein={datein}
          dateout={dateout}
          onClose={onClose}
        />
      )}
      {currentStep === "services" && (
        <BookingFormServices
          booking={booking}
          bookingData={bookingData}
          hoteldata={hoteldata}
          prevStep={prevStep}
          nextStep={nextStep}
          datein={datein}
          dateout={dateout}
          onClose={onClose}
        />
      )}
      {currentStep === "contacts" && (
        <BookingFormContacts
          booking={booking}
          bookingData={bookingData}
          hoteldata={hoteldata}
          prevStep={prevStep}
          datein={datein}
          dateout={dateout}
          bookingHandler={bookingHandler}
          onClose={onClose}
        />
      )}
      {currentStep === "final" && (
        <BookingFormFinal
          hoteldata={hoteldata}
          finalData={finalData}
          datein={datein}
          dateout={dateout}
          onClose={onClose}
        />
      )}
      {currentStep === "redirect" && <p>Загрузка...</p>}
    </>
  );
}

export default BookingWindow;
